import {IgenomicsAction} from '@ispm/core/interfaces/genomics-action.interface';
import * as immutable from 'immutable';
import {CLINICALDASHBOARD_ACTIONS} from "@ispm-client/modules/clinical-dashboard/store/actions";
import {
  IClinicalTrendType
} from "@ispm-client/modules/clinical-dashboard/interfaces/clinica-trends.interface";


export interface IClinicalDashboardAndSelectedState {
  selectedClinicalDashboard: any;
  trendGroups: Array<IClinicalTrendType>;
  trendFilter: Date[];

}

const initClinicalDashboardState: IClinicalDashboardAndSelectedState = {
  selectedClinicalDashboard: null,
  trendGroups: [],
  trendFilter: []

  }
;

export function clinicalDashboardReducer(state: IClinicalDashboardAndSelectedState = initClinicalDashboardState,
                                         action: IgenomicsAction<any>): IClinicalDashboardAndSelectedState {
  switch (action.type) {
    case CLINICALDASHBOARD_ACTIONS.CLEAR_CLINICAL_DASHBOARD:
      // state.eventsDefinition = action.payload.upsert(state.eventsDefinition);
      return Object.assign({}, state, {selectedClinicalDashboard: immutable.Map()});
    case CLINICALDASHBOARD_ACTIONS.CHANGE_SELECTED_DASHBOARD:
      // state.selectedEvent = action.payload.upsert(state.selectedClinicalDashboard);
      return Object.assign({}, state, {selectedClinicalDashboard: action.payload});

    case CLINICALDASHBOARD_ACTIONS.UPDATE_TREND_GROUPS:
      // state.selectedEvent = action.payload.upsert(state.selectedClinicalDashboard);
      return Object.assign({}, state, {trendGroups: action.payload});

    case CLINICALDASHBOARD_ACTIONS.UPDATE_TREND_SELECTED_FILTER:
      // state.selectedEvent = action.payload.upsert(state.selectedClinicalDashboard);
      return Object.assign({}, state, {trendFilter: action.payload});

    case CLINICALDASHBOARD_ACTIONS.CLEAR_CLINICAL_TREND_GROUPS:
      // state.eventsDefinition = action.payload.upsert(state.eventsDefinition);
      return Object.assign({}, state, {trendGroups: []});
    default:
      return state;
  }
}
